import React from 'react';
import './PlayToEarn.css';

const PlayToEarn = () => {
  return (
    <div className="play-to-earn-container">
      <h1>Start Earning Now!</h1>
      <p>Click the link below to start playing and earning with EarnStar.</p>
      <div className="earnstar-card">
        <h2>Play Games, Earn Cash</h2>
        <a href="https://www.earnstar.com" target="_blank" rel="noopener noreferrer">Go to EarnStar</a>
      </div>
    </div>
  );
};

export default PlayToEarn;
